import React, { useEffect, useRef, useState } from 'react'
import { Form, Row, Col, Button, Spinner, InputGroup, Card, Modal, CloseButton } from 'react-bootstrap'
import { useSelector } from 'react-redux';
import ServerError from '../../controls/ServerError';
import { dateDisplayFormater, getDateSaveFormat } from '../../../Utils';
import { json, useNavigate } from 'react-router-dom';
import DataGrid from '../../controls/DataGrid.js/DataGrid';
import DynamicDropdownSearchable from '../../controls/DynamicDropdownSearchable';
import PCPGoalTypeModal from './PCPGoalTypeModal';
import "./PCPGoal.css";
import DynamicDropdownSearchableForClient from '../../controls/DynamicDropdownSearchableForClient';


export default function PCPGoalClientSearchForm({ afterImportgoals,  onCancel }) {
    const state = useSelector(state => state);
    const [loading, setLoading] = useState(false);
    const [validated, setValidated] = useState(false);
    const [refreshGrid, setRefreshGrid] = useState(false);
    const [showClientList,setshowCilentList] =useState(false);
    const firstnameRef = useRef(null);
    let today = new Date()
    let saveDate = getDateSaveFormat(today);
    const [querystring,setquerystring]=useState("");
    const [currentUserId,setcurrentUserId] = useState(0);
       const [dropdownvalue,setdropdownvalue]=useState({
        UserId:0,
    })
    const [inputValue, setInputValue] = useState({
       // DOB:null,
        FirstName: "",
        LastName: "",
        UCINumber:"",
        MotherName: "",
        UserId:0,
        FatherName:"",
        CreatedBy:""
    });
    const [serverError, setServerError] = useState({});
    const handleChange = ((e) => {
        const name = e.target.name;
        let value = e.target.value.trim();
        let maxLength = e.target.maxLength;
        if (e.target.type == "checkbox") {
            value = e.target.checked;
        }
        else {
            if (maxLength && maxLength > 0 && value.length > maxLength) {
                return;
            }
        }
        setInputValue(c => ({ ...c, [name]: value }));
    });
    useEffect(() => {
       firstnameRef.current.focus();
       setshowCilentList(false);
        let loggedinUser = JSON.parse(localStorage.getItem("user"));
        setcurrentUserId(loggedinUser?.Id);
        
    }, []);

    const handleSubmit = ((e) => {
        e.preventDefault();
        e.stopPropagation();
        const form = e.currentTarget;
        
        if(inputValue.FirstName.trim()=="" && inputValue.LastName.trim()=="" 
        && inputValue.MotherName.trim() =="" && inputValue.UCINumber.trim()==""
        && inputValue.CreatedBy =="" && inputValue.FatherName.trim()==""
        )
        {
            window.alert("Please enter firstname or lastname or mothername or ucinumber or fathername values");
            firstnameRef.current.focus();
             setshowCilentList(false);
            return false;
        }
        if (form.checkValidity() === false) {
            setValidated(true);
        }
        else {
            
           setLoading(true);
           // setshowCilentList(true);
             setquerystring( new URLSearchParams({
                FirstName: inputValue.FirstName,
                LastName:inputValue.LastName,
                UCINumber:inputValue.UCINumber,
                MotherName: inputValue.MotherName,
                FatherName:inputValue.FatherName,
                CreatedBy:inputValue.CreatedBy
                }).toString());

               setRefreshGrid(!refreshGrid);
               setshowCilentList(true);
               setLoading(false);
        }
      
    })
    const navigate = useNavigate();

        const options = {
        dataType: "server",
        showExport: false,
        showRefresh: false,
        sortName: "CreatedDate",
        sortOrder: "desc",
        exportDocumetName: "Clients",
        inputvalue:inputValue
      };

    
const columns = [
        {
            field: "FirstName",
            title: "First Name",
            sortName: "FirstName",
            sortable: true,
        },
        {
            field: "LastName",
            title: "Last Name",
            sortable: true,
        },
        {
            field: "MotherName",
            title: "Mother's Name",
            sortable: true,
        },
         {
             field: "UCINumber",
            title: "UCI Number",
             sortable: true,
            visible:true,
        },
        {
            field: "FatherName",
            title: "Father Name",
            sortable: true,
        },
        {
            field: "user.name",
            title: "Created By",
            sortable: false,
            visible: true
        },
        {
                    dataField: "select",
                    title: "",
                    text: "Select",
                    formatter: (cellContent, row) => {
                        return (<div>
                            {state.access.edit ? <Button
                                className="btn-xs me-2 mb-2 p-0" variant="link"
                                onClick={() => handleSelect(row)}
                            >Select</Button> : ""}
                        </div>
                        );
                    },
        }


    ];
    const [ShowGoaltypeList,setShowGoaltypeList] = useState(false);
    const [ClientId,setClientId]=useState("");
    const [ClientName,setClientName] = useState("");
    const handleSelect = (row) => {
      setClientId(row.Id);
      setClientName(row.FirstName + " " + row.LastName);
      setShowGoaltypeList(true);
    };

    const handleDropdownChange = (e) => {

            let value = e.target.value;
            if (value>0){
                setdropdownvalue(c=>({...c,["UserId"]:value}));
                inputValue.CreatedBy = value;
            }else{
                inputValue.CreatedBy="";
            }
        };

    const handleClose = () => {
       
        afterImportgoals("", "", "", "", "", "", "", "");
    };
const handleAfter =(socialAction,personalAction,professionalAction,healthandSafetyAction,selectedSocialGoals,selectedpersonalGoals,selectedprofessionalGoals,selectedhealthandSafetyGoals)=>{
  
    setShowGoaltypeList(false);
    setshowCilentList(false);
    afterImportgoals(socialAction, personalAction, professionalAction, healthandSafetyAction, selectedSocialGoals, selectedpersonalGoals, selectedprofessionalGoals, selectedhealthandSafetyGoals);
    }


    return (
         <div>
        { !ShowGoaltypeList && (
       <Form noValidate validated={validated} onSubmit={handleSubmit} >
                   <Row className="mb-1" >
                       <Col md={6}>
                               <Form.Group>
                                   <Form.Label>First Name<code className='required-symbol'>*</code></Form.Label>
                                   <Form.Control  type="text" ref={firstnameRef} name="FirstName" value={inputValue.FirstName} onChange={handleChange} autoComplete="off" />
                                   <Form.Control.Feedback type="invalid">First Name is required</Form.Control.Feedback>
                               </Form.Group>
                       </Col>
                       <Col md={6}>
                               <Form.Group>
                                   <Form.Label>Last Name</Form.Label>
                                   <Form.Control type="text" name="LastName" value={inputValue.LastName} onChange={handleChange} autoComplete="off" />
                               </Form.Group>
                       </Col>
                    </Row>
                    <Row className="mb-1">
                       <Col md={6}>
                           
                               <Form.Group>
                                   <Form.Label>UCI Number<code className='required-symbol'>*</code></Form.Label>
                                   <Form.Control  type="text" name="UCINumber" value={inputValue.UCINumber} onChange={handleChange} autoComplete="off" />
                                   <Form.Control.Feedback type="invalid">UCI Number is required</Form.Control.Feedback>
                               </Form.Group>
                          
                       </Col>
                       <Col md={6}>
                          
                               <Form.Group>
                                   <Form.Label>Mother's Name</Form.Label>
                                   <Form.Control type="text" name="MotherName" value={inputValue.MotherName} onChange={handleChange} autoComplete="off" />
                               </Form.Group>
                       </Col>
                       </Row>

                       <Row className="mb-1">
                       <Col md={6}>
                            <Form.Label>Created By</Form.Label>
                           <DynamicDropdownSearchableForClient  from={state.projectdetail.API + "/User/GetAll"} label="name" value="Id" fetchType="get" name="Id" onDropdownChange={handleDropdownChange} defaulval={dropdownvalue.UserId} initialOption="--Select All--"/>
                                 
                       </Col>
                       <Col md={6}>
                          
                               <Form.Group>
                                   <Form.Label>Father's Name</Form.Label>
                                   <Form.Control type="text" name="FatherName" value={inputValue.FatherName} onChange={handleChange} autoComplete="off" />
                               </Form.Group>
                       </Col>
                       </Row>
       
                   <Row className="mb-3">
                       <Col md={12}>
                           <ServerError error={serverError} />
                       </Col>
                   </Row>
                   <Row className="mb-1">
                    <Col md={9}></Col>
                       <Col className='text-center' md={3}>
                           <Button variant="outline-primary" onClick={onCancel} disabled={loading}>
                               Cancel
                               {loading ? <Spinner as="span" animation="grow" size="sm" role="status" aria-hidden="true" /> : ""}
                           </Button>&nbsp;&nbsp;
                           <Button variant="primary" type="submit" disabled={loading}>
                               Search
                               {loading ? <Spinner as="span"  animation="grow" size="sm" role="status" aria-hidden="true" /> : ""}
                           </Button>
                       </Col>
                   </Row>
                 {showClientList && 
            <Row className="mb-6">
                <Col md={12}>
                    <h6> 
                        Client List
                    </h6>
                </Col>
            </Row>
            }
            {showClientList && 
            <Row className="mb-1">
                <Card>
                    <Card.Body>
                        {loading ? <div className="text-center"><Spinner as="span" animation="border" size="lg" role="status" aria-hidden="true" /> </div> : ""}
                                    <DataGrid url={state.projectdetail.API + "/client/SearchClientGrid?"+querystring}   classes="table table-striped" options={options} columns={columns} refresh={refreshGrid} showExport="false" showRefresh="false"/>
                    </Card.Body>
                </Card>
            </Row>
            }
        </Form>
       ) }

             <Modal show={ShowGoaltypeList} onHide={handleClose} 
                 size="lg" backdrop="static"  keyboard={false} scrollable
                 dialogClassName="custom-modal-position" style={{overflow: "hidden"}} >
                  <Modal.Header style={{background: "#0a4081",color:"white"}}>
                   <h4> Goal Details for the {ClientName}</h4>
                   <CloseButton  onClick={handleClose} className="btn-close" />
                   </Modal.Header>
                    <Modal.Body>
                    <PCPGoalTypeModal _ClientId={ClientId} _ClientName={ClientName} _inputValue={inputValue} afterSave={handleAfter}  onCancel={handleClose} />
                    </Modal.Body>
                    </Modal>

</div>
    );
}
